import { ProverData } from "@/components/AppList";
import { create } from "zustand";
import { createJSONStorage, persist, PersistOptions } from "zustand/middleware";

export enum SubmitStatus {
  INIT,
  SUBMITTING,
  SUCCESS,
}
export enum WalletSource {
  FromWeb,
  FromMobile,
}
export enum HookType {
  ConcentratedLiquidity,
  TokenHolding,
  Euler,
}

interface MyState {
  isMobile: boolean;
  walletSource: WalletSource;
  selectedStake: ProverData | undefined;
  // getDataLoading: boolean;
  // getListLoading: boolean;
  // userLoading: boolean;
  refreshData: boolean;
  tokenPrice: number;

  setIsMobile: (value: boolean) => void;
  setWalletSource: (value: WalletSource) => void;
  setSelectedStake: (value: ProverData) => void;
  // setGetDataLoading: (value: boolean) => void;
  // setGetListLoading: (value: boolean) => void;
  // setUserLoading: (value: boolean) => void;
  setRefreshData: () => void;
  setTokenPrice: (value: number) => void;
}
type PersistedState = Pick<MyState, "isMobile">;
export const useDataStore = create(
  persist(
    (set, _Partial, state) => ({
      isMobile: false,
      walletSource: WalletSource.FromWeb,
      selectedStake: undefined,
      // userInfoRes: undefined,
      // userTaskListRes: undefined,
      // userPointHistoryRes: undefined,
      // getDataLoading: true,
      // getListLoading: true,
      // userLoading: false,
      refreshData: false,
      tokenPrice: 1,

      setIsMobile: (value) => {
        set({ isMobile: value });
      },
      setWalletSource: (value) => {
        set({ walletSource: value });
      },
      setSelectedStake: (value) => {
        set({ selectedStake: value });
      },
      // setGetDataLoading: (value) => {
      //   set({ getDataLoading: value });
      // },
      // setGetListLoading: (value) => {
      //   set({ getListLoading: value });
      // },
      // setUserLoading: (value) => {
      //   set({ userLoading: value });
      // },
      setRefreshData: () => {
        set((state) => ({ refreshData: !state.refreshData }));
      },
      setTokenPrice: (value) => {
        set({ tokenPrice: value });
      },
    }),
    {
      name: "my-store",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isMobile: state.isMobile,
        walletSource: state.walletSource,
      }),
    } as PersistOptions<MyState, PersistedState>
  )
);
